/* eslint-disable max-len */
/* eslint-disable complexity */

import Conciliation2Bank from './conciliation2-bank';
import Conciliation2RDOperations from './conciliation2-rd-operations';
import Conciliation2Resume from './conciliation2-resume';
import Conciliation2Historic from './conciliation2-historic';
import Conciliation2Store from '@/store/conciliation2/index.js';
import commonFunctions from '../common-functions';

export default {
    name: 'conciliation2-details',

    extends: commonFunctions,

    components: {
        Conciliation2Bank,
        Conciliation2RDOperations,
        Conciliation2Resume,
        Conciliation2Historic
    },

    data() {
        return {
            monitorType: 'all',
            product: '',
            currency: '',
            bankOperations: [],
            keyUpdateBankOperations: 0,
            RDOperations: [],
            keyUpdateRDOperations: 0,
            bankOperationsSort: {
                sortBy: 'transaction_date',
                sortDesc: true
            },
            bankOperationsColumnFilters: {
                transaction_date: '',
                key_product: '',
                concept: '',
                gross_amount: ''
            },
            RDOperationsSort: {
                sortBy: 'transaction_date',
                sortDesc: true
            },
            RDOperationsColumnFilters: {
                transaction_date: '',
                key_product: '',
                concept: '',
                gross_amount: ''
            },
            difference: 0,
            isCuadrada: true,
            isLoaded: false,
            historicData: null
        };
    },

    /**
     * Comprueba que la URL cambia y obtiene los datos
     */
    watch: {
        $route: {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            async handler() {
                this.isLoaded = false;
                this.product = this.$route.query.product;
                this.currency = this.$route.query.currency;
                await this.fetchCurrentData();
                this.difference = (this.bankOperations.total || 0) - (this.RDOperations.total || 0);
                this.isCuadrada = (this.difference === 0);
                this.isLoaded = true;
            }
        }
    },

    beforeMount() {
        this.product = this.$route.query.product;
        this.currency = this.$route.query.currency;
        if (!this.$store._modules.root._children[`Conciliation2Detail${this.product}-${this.currency}`]) {
            // Actualizar a vuex 3.2 para poder usar el método: hasModule: https://vuex.vuejs.org/api/#hasmodule
            this.$store.registerModule(`Conciliation2Detail${this.product}-${this.currency}`, Conciliation2Store);
        }
    },

    async mounted() {
        this.$root.$on('filter_bankOperations', this.filterBankOperations);
        this.$root.$on('filter_RDOperations', this.filterRDOperations);
        this.$root.$on('filter_columns_bankOperations', this.filterColumnsBankOperations);
        this.$root.$on('filter_columns_RDOperations', this.filterColumnsRDOperations);
        this.$root.$on('fetch_data', this.fetchDataAfterConciliation);
        await this.fetchCurrentData();
        this.difference =  (this.bankOperations.total || 0) - (this.RDOperations.total || 0);
        this.isCuadrada = (this.difference === 0);
        this.isLoaded = true;
    },

    methods: {
        async fetchDataAfterConciliation() {
            this.isLoaded = false;
            await this.fetchCurrentData();
            this.difference =  (this.bankOperations.total || 0) - (this.RDOperations.total || 0);
            this.isCuadrada = (this.difference === 0);
            this.isLoaded = true;
        },

        async fetchCurrentData() {
            await Promise.all([
                this.loadBankOperations(),
                this.loadRDOperations()
            ]);
        },
        async fetchHistoricData(filterToApply = {}) {
            const params = {
                $limit: 15
            };
            params['$filter'] = JSON.stringify(filterToApply);
            const directionTransfers = this.bankOperationsSort.sortDesc ? 'desc' : 'asc';
            params['$orderby'] = `${this.bankOperationsSort.sortBy} ${directionTransfers}`;
            const res = await this.$paymentsService.getHistoricConciliaion2({
                product: this.product,
                currency: this.currency,
                params
            });
            this.historicData = res.data.reconciliations;
            this.historicData.metadata = res.metadata;
            this.keyUpdateHistoricData++;
        },
        async loadBankOperations(filterToApply = {}) {
            const params = {
                $limit: 15,
                $expand: 'reconciliation'
            };
            params['$filter'] = JSON.stringify(filterToApply);
            const directionTransfers = this.bankOperationsSort.sortDesc ? 'desc' : 'asc';
            params['$orderby'] = `${this.bankOperationsSort.sortBy} ${directionTransfers}`;
            const res = await this.$paymentsService.getBankOperations({
                product: this.product,
                currency: this.currency,
                params
            });
            this.bankOperations = res.data.items;
            this.bankOperations.metadata = res.metadata;
            this.bankOperations.synchronized = res.metadata.synchronized;
            this.bankOperations.total = res.metadata.total;
            this.keyUpdateBankOperations++;
        },
        async loadRDOperations(filterToApply = {}) {
            const params = {
                $limit: 15,
                $expand: 'reconciliation',
                params
            };
            params['$filter'] = JSON.stringify(filterToApply);
            const directionTransfers = this.bankOperationsSort.sortDesc ? 'desc' : 'asc';
            params['$orderby'] = `${this.bankOperationsSort.sortBy} ${directionTransfers}`;
            const res = await this.$paymentsService.loadRDOperations({
                product: this.product,
                currency: this.currency
            });
            this.RDOperations = res.data.items;
            this.RDOperations.metadata = res.metadata;
            this.RDOperations.synchronized = res.metadata.synchronized;
            this.RDOperations.total = res.metadata.total;
            this.keyUpdateRDOperations++;
        },

        filterBankOperations(sort) {
            const filterToApply = {};

            for (const columnFilter in this.bankOperationsColumnFilters) {
                if (this.bankOperationsColumnFilters[columnFilter]) {
                    if (columnFilter === 'transaction_date') {
                        if (this.bankOperationsColumnFilters[columnFilter].endDate && this.bankOperationsColumnFilters[columnFilter].startDate) {
                            const firstDay = this.$moment(this.bankOperationsColumnFilters[columnFilter].startDate)
                                .format('YYYY/MM/DD');
                            const lastDay = this.$moment(this.bankOperationsColumnFilters[columnFilter].endDate)
                                .add(1, 'days')
                                .format('YYYY/MM/DD');
                            filterToApply[columnFilter] = [
                                { gte: firstDay },
                                { lte: lastDay }
                            ];
                        }
                    } else if (columnFilter === 'gross_amount') {
                        filterToApply[columnFilter] = [
                            { gte: this.bankOperationsColumnFilters[columnFilter][0] },
                            { lte: this.bankOperationsColumnFilters[columnFilter][1] }
                        ];
                    } else {
                        filterToApply[columnFilter] = [
                            { in: `%${this.bankOperationsColumnFilters[columnFilter]}%` }
                        ];
                    }
                }
            }

            if (sort) {
                this.bankOperationsSort.sortBy = sort.sortBy;
                this.bankOperationsSort.sortDesc = sort.sortDesc;
            }

            return this.loadBankOperations(filterToApply);
        },

        filterColumnsBankOperations(filters) {
            this.bankOperationsColumnFilters = filters;
            this.filterBankOperations();
        },

        filterRDOperations(sort) {
            const filterToApply = {};

            for (const columnFilter in this.RDOperationsColumnFilters) {
                if (this.RDOperationsColumnFilters[columnFilter]) {
                    if (columnFilter === 'transaction_date') {
                        if (this.RDOperationsColumnFilters[columnFilter].endDate && this.RDOperationsColumnFilters[columnFilter].startDate) {
                            const firstDay = this.$moment(this.RDOperationsColumnFilters[columnFilter].startDate)
                                .format('YYYY/MM/DD');
                            const lastDay = this.$moment(this.RDOperationsColumnFilters[columnFilter].endDate)
                                .add(1, 'days')
                                .format('YYYY/MM/DD');
                            filterToApply[columnFilter] = [
                                { gte: firstDay },
                                { lte: lastDay }
                            ];
                        }
                    } else if (columnFilter === 'gross_amount') {
                        filterToApply[columnFilter] = [
                            { gte: this.RDOperationsColumnFilters[columnFilter][0] },
                            { lte: this.RDOperationsColumnFilters[columnFilter][1] }
                        ];
                    } else {
                        filterToApply[columnFilter] = [
                            { in: `%${this.RDOperationsColumnFilters[columnFilter]}%` }
                        ];
                    }
                }
            }

            if (sort) {
                this.operationsSort.sortBy = sort.sortBy;
                this.operationsSort.sortDesc = sort.sortDesc;
            }

            return this.loadRDOperations(filterToApply);
        },

        filterColumnsRDOperations(filters) {
            this.RDOperationsColumnFilters = filters;
            this.filterRDOperations();
        },

        async changeMonitorType(type) {
            this.isLoaded = false;
            this.monitorType = type;
            this.clearSelection(`Conciliation2Detail${this.product}-${this.currency}`);
            if (type === 'historic') {
                await this.fetchHistoricData();
                this.isLoaded = true;
            } else {
                this.bankOperations = [];
                this.RDOperations = [];
                this.bankOperationsColumnFilters = {
                    transaction_date: '',
                    key_product: '',
                    concept: '',
                    gross_amount: ''
                };
                this.RDOperationsColumnFilters = {
                    transaction_date: '',
                    key_product: '',
                    concept: '',
                    gross_amount: ''
                };
                await this.fetchHistoricData();
                await this.fetchCurrentData();
                this.difference = (this.bankOperations.total || 0) - (this.RDOperations.total || 0);
                this.isCuadrada = (this.difference === 0);
                this.isLoaded = true;
            }
        }
    },

    computed: {
        viewResume() {
            const bankOperations = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/bankOperations`] || [];
            const RDOperations = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/RDOperations`] || [];
            return bankOperations.length || RDOperations.length;
        },
        isFullScreen() {
            return this.$store.getters['fullscreenStore/fullscreen'];
        }
    },
    /**
     * @override
     */
    beforeDestroy() {
        this.$root.$off('filter_bankOperations', this.filterBankOperations);
        this.$root.$off('filter_RDOperations', this.filterRDOperations);
        this.$root.$off('filter_columns_bankOperations', this.filterColumnsBankOperations);
        this.$root.$off('filter_columns_RDOperations', this.filterColumnsRDOperations);
        this.$root.$off('fetch_data', this.fetchDataAfterConciliation);
    }
};
